module.exports = __webpack_public_path__ + "7c603e98950e31120fd5e9f863d246ef.MP3";